import { IconButton } from '@mui/material';
import { useCreate, useNotify } from 'react-admin';
import { MANAGER_PLACES } from '@/utils/CONST';
import LinkIcon from '@mui/icons-material/Link';
import useGetCurrentUser from '@/hooks/useGetCurrentUser';

interface Props {
    avatarUriId: string;
    userId: string;
}
const ActionField = ({ avatarUriId, userId }: Props) => {
    const notify = useNotify();
    const [create, { isLoading: isLoadingCreate }] = useCreate();
    const { currentUser } = useGetCurrentUser();

    const handleAddTo = () => {
        create(
            MANAGER_PLACES,
            {
                data: {
                    placeOrEvent: avatarUriId,
                    company: currentUser?.company,
                    userManager: userId,
                },
            },
            {
                onSuccess: () => {
                    notify('messages.associated', { type: 'success' });
                },
            },
        );
    };

    return (
        <IconButton
            disabled={isLoadingCreate}
            onClick={handleAddTo}
            color={'primary'}
            sx={{
                p: 0,
            }}
            data-cy={'link-user'}
        >
            <LinkIcon />
        </IconButton>
    );
};

export default ActionField;
